/** True only for iPhone (not iPad, not Android). Used to isolate Safari bugs. */
export function isIPhone(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /iPhone/i.test(navigator.userAgent);
}

export function markIPhoneDocument(): void {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.toggle('tp-iphone', isIPhone());
}
